import { render, staticRenderFns } from "./SrListItemGroup.vue?vue&type=template&id=dbccd704"
import script from "./SrListItemGroup.vue?vue&type=script&lang=js"
export * from "./SrListItemGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports